import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { APISettings } from '../../misc/settings';
import { Credentials } from '../../models/settings/credentials';
import { CredentialsGroup } from '../../models/settings/CredentialsGroup';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {

  constructor(private http: HttpClient) { }

  getCredentials(): Observable<CredentialsGroup[]> {
    return this.http.get<CredentialsGroup[]>(`${APISettings.apiBaseAddress}/api/credentials/getall`);
  }

  getCredentialGroups(): Observable<CredentialsGroup[]> {
    return this.http.get<CredentialsGroup[]>(`${APISettings.apiBaseAddress}/api/credentials/getgroups`);
  }

  addCredentials(credentials: Credentials): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/credentials/add`,
      credentials, APISettings.httpOptions);
  }

  updateCredentials(credentials: Credentials): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/credentials/update`,
      credentials, APISettings.httpOptions);
  }

  deleteCredentials(credentials: Credentials): Observable<string> {
    return this.http.post<string>(`${APISettings.apiBaseAddress}/api/credentials/delete`,
      credentials, APISettings.httpOptions);
  }
}
